import comp from "./AssessmentCoverUpload";
export default comp;
